import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '@/api';
import {
    HiArrowLeft,
    HiOutlineBuildingOffice2,
    HiOutlineCalendarDays,
    HiOutlineBriefcase,
    HiOutlineBanknotes,
    HiOutlineClipboardDocumentCheck,
    HiOutlineUser
} from 'react-icons/hi2';
import { toArray } from "../utils/toArray";
import { splitDateCollab } from "../utils/splitDateCollab";

// Composant pour la carte d'une offre
const OfferCard = ({ offre, matchPercentage, summary }) => {
    const getBadgeColor = (percent) => {
        if (percent >= 75) return 'bg-green-500 text-white';
        if (percent >= 50) return 'bg-yellow-500 text-white';
        return 'bg-red-500 text-white';
    };
    const { date, collab } = splitDateCollab(offre.dateCollaboration || "");

    return (
        <div className="bg-pro-dark-surface rounded-lg p-6 border border-pro-dark-border transform hover:-translate-y-1 transition-transform duration-300 flex flex-col justify-between">
            <div>
                <div className="flex justify-between items-start">
                    <div>
                        {/* CORRECTION : Utilisation de 'detailDuBesoin' au lieu de 'detail_du_besoin' */}
                        <h3 className="text-lg font-bold text-pro-dark-text-primary">{offre.detailDuBesoin}</h3>
                        <p className="text-sm text-pro-dark-text-secondary flex items-center gap-2 mt-1"><HiOutlineBuildingOffice2 /> {offre.compte}</p>
                    </div>
                    <div className={`px-3 py-1 text-sm font-bold rounded-full ${getBadgeColor(matchPercentage)}`}>
                        {matchPercentage}%
                    </div>
                </div>
                <p className="mt-4 text-sm text-pro-dark-text-secondary italic">"{summary}"</p>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-2 text-xs text-pro-dark-text-secondary border-t border-pro-dark-border pt-4">
                <span className="flex items-center gap-1"><HiOutlineBriefcase /> {offre.niveauExp || 'N/A'}</span>
                <span className="flex items-center gap-1"><HiOutlineCalendarDays /> {date || 'N/A'}</span>
                {collab && (
                    <span className="flex items-center gap-1"><HiOutlineUser /> {collab}</span>
                )}
                <span className="flex items-center gap-1"><HiOutlineBanknotes /> TJM: {offre.tjmAnnonce ? `${offre.tjmAnnonce}€` : 'N/A'}</span>
                <span className="flex items-center gap-1"><HiOutlineClipboardDocumentCheck /> Statut: {offre.statut || 'N/A'}</span>
            </div>
        </div>
    );
};

const MatchingOffresPage = () => {
    const { id } = useParams();
    const [matches, setMatches] = useState([]);
    const [candidat, setCandidat] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchMatches = async () => {
            setIsLoading(true);
            try {
                const candidatResponse = await api.get(`/candidats/${id}`);
                setCandidat(candidatResponse.data);
                
                const matchesResponse = await api.get(`/candidats/${id}/matches`);
                setMatches(Array.isArray(matchesResponse.data) ? matchesResponse.data : []);
            } catch (error) {
                console.error("Erreur lors de la récupération des correspondances:", error);
                setMatches([]);
            } finally {
                setIsLoading(false);
            }
        };
        fetchMatches();
    }, [id]);

    if (isLoading) {
        return <p className="text-center text-pro-dark-text-secondary">Calcul des correspondances en cours...</p>;
    }

    return (
        <div>
            <Link to="/candidats" className="flex items-center gap-2 text-sm text-pro-dark-text-secondary hover:text-pro-dark-accent mb-6">
                <HiArrowLeft />
                Retour à la liste des candidats
            </Link>
            {candidat && (
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-pro-dark-text-primary">Offres correspondantes pour : {candidat.prenom} {candidat.nom}</h1>
                    <p className="text-md text-pro-dark-text-secondary">Poste actuel : {candidat.posteActuel}</p>
                </div>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {toArray(matches).map(match => (
                    <OfferCard
                        key={match.offre.id}
                        offre={match.offre}
                        matchPercentage={match.finalScore}
                        summary={match.summary}
                    />
                ))}
            </div>
             {matches.length === 0 && !isLoading && (
                <div className="text-center py-12">
                    <p className="text-pro-dark-text-secondary">Aucune offre correspondante trouvée.</p>
                </div>
            )}
        </div>
    );
};

export default MatchingOffresPage;